import { useLocation, useNavigate } from 'react-router-dom'
import Logo from 'assets/img/logo-notext.svg'
import { useEffect, useState } from 'react'
import { GET } from 'api/request'
import * as url from 'api/urls'
import './index.scss'

const Unpublished = () => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const [data, setData] = useState<board.BoardResponse | null>()

  const profileId = pathname.split('/unpublished/')[1]

  const fetchProfile = async () => {
    try {
      const response = await GET(`${url.boards}/${profileId}`)
      if (response.ok) {
        setData(response.data)
      } else {
        throw new Error('Failed to fetch profile')
      }
    } catch (err) {
      console.error(err)
    }
  }

  useEffect(() => {
    fetchProfile()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname])

  return (
    <div className='unpublished'>
      <div
        className="unpublished__logo"
        onClick={() => {
          navigate('https://mojekondolencje.pl')
        }}>
        <img src={Logo} alt="logo" />
        <h2>Profil ukryty</h2>
      </div>
      <div className="unpublished__content">
        {data?.data.isOwned
          ? <div>
            <div className="warning">
              Wygląda na to, że jesteś właścicielem tego profilu
            </div>
            <button className="btn btn--primary" onClick={() => navigate(`/manage/${profileId}`)}>Przejdź do zarządzania</button>
          </div>
          : <div>
            <div className="warning">
              Jeżeli jesteś właścicielem tego profilu, przejdź do logowania
            </div>
            <button className="btn btn--primary" onClick={() => navigate('/login')}>Przejdź do logowania</button>
          </div>}
      </div>
      <div className="unpublished__footer">
        <span onClick={() => navigate('/help')}>Pomoc</span>
        <span onClick={() => window.open('https://mojekondolencje.pl/polityka-prywatnosci')}>Polityka prywatności</span>
        <span onClick={() => window.open('https://mojekondolencje.pl/regulamin')}>Regulamin</span>
      </div>
    </div>
  )
}

export default Unpublished